var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { throwError } from 'cerebral/internal';
var Container = /** @class */ (function (_super) {
    __extends(Container, _super);
    function Container() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Container.prototype.getChildContext = function () {
        var controller = this.props.controller;
        if (!controller) {
            throwError('You are not passing controller to Container');
        }
        return { controller: controller };
    };
    Container.prototype.render = function () {
        return this.props.children;
    };
    Container.propTypes = {
        controller: PropTypes.object.isRequired,
        children: PropTypes.node.isRequired,
    };
    Container.childContextTypes = {
        controller: PropTypes.object.isRequired,
    };
    return Container;
}(React.Component));
export default Container;
//# sourceMappingURL=Container.js.map


//////////////////
// WEBPACK FOOTER
// /home/kryd0s/tmp/widgetbot/node_modules/@cerebral/fluent/es/Container.js
// module id = 158
// module chunks = 0